export class CatalogDatabase {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableCount",
            "baseName": "tableCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CatalogDatabase.attributeTypeMap;
    }
    constructor() {
    }
}
